import { createContext, useContext } from 'react';
import type { ReactNode } from 'react';

import type { ProjectDashboardProject } from '../projectDashboardTypes';

const defaultProjectValue: ProjectDashboardProject = {
  data: undefined,
  status: {
    loading: false,
    error: undefined,
  },
};

export const ProjectContext = createContext<ProjectDashboardProject>(defaultProjectValue);

export const useProject = () => {
  return useContext(ProjectContext);
};

type ProjectProviderProps = {
  children: ReactNode;
  value: ProjectDashboardProject;
};

export const ProjectProvider = ({ children, value }: ProjectProviderProps) => (
  <ProjectContext.Provider value={value}>
    {children}
  </ProjectContext.Provider>
);

export default ProjectProvider;
